import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const SmallRightIcon = createSvgIcon(
  <>
    <title>small right</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <polyline
        fill="none"
        points="13,10 19,16 13,22 "
        stroke="#222222"
        strokeMiterlimit="10"
        transform="translate(0, 0)"
      />
    </g>
  </>
)
